import hwkAPI from './v1/hwkApi';

const API_CONFIG_DEV = { // eslint-disable-line no-unused-vars
  apiUrl: 'http://api.hwk.test',
  staticUrl: 'http://hwk.test',
  webUrl: 'http://hwk.test',
  token: 'xXxXhwkDemoAuthTokenXxXx',
  debug: true
}

const API_CONFIG_BOOM = { // eslint-disable-line no-unused-vars
  apiUrl: 'http://api.hwk.styleflasher.at',
  staticUrl: 'http://hwk.styleflasher.at',
  webUrl: 'http://hwk.styleflasher.at',
  token: 'xXxXhwkDemoAuthTokenXxXx',
  debug: true
}

const API_CONFIG_HWK = { // eslint-disable-line no-unused-vars
  apiUrl: 'https://api.hwk-skiwachs.de',
  staticUrl: 'https://api.hwk-skiwachs.de',
  webUrl: 'https://api.hwk-skiwachs.de',
  token: 'xXxXhwkDemoAuthTokenXxXx',
  debug: false
}

const API_CONFIG = process.env.NODE_ENV === "development" ? API_CONFIG_DEV : API_CONFIG_HWK;
const API = new hwkAPI(API_CONFIG);

export {
  API_CONFIG,
  API
}
